.spfArrow {
  font-family: monospace;
}

.selectDropdown {
  max-height: 400px;
  overflow: auto;

  &Pagination {
    padding: var(--dixa-size-spacer-250);
    position: sticky;
    bottom: 0;
    align-self: flex-end;
    background: var(--dixa-color-neutral-000);
    border-top: var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);
  }
}
